import { render, staticRenderFns } from "./NumberedList.vue?vue&type=template&id=6f7e5320&scoped=true"
import script from "./NumberedList.vue?vue&type=script&lang=js"
export * from "./NumberedList.vue?vue&type=script&lang=js"
import style0 from "./NumberedList.vue?vue&type=style&index=0&id=6f7e5320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7e5320",
  null
  
)

export default component.exports